/**
 * Programmatically invoke the Google reCAPTCHA v3 challenge.
 * @param {String} action
 * @return {Promise} promise will resolve to the token or reject with a suitable error
 *     if something goes wrong. Undefined if reCAPTCHA is not enabled.
 */
export function invokeChallengeAsync(actionName) {

    // if we aren't using reCAPTCHA then return an undefined token
    if (typeof window.grecaptcha == "undefined") {
        return Promise.resolve(undefined);
    }

    let timer;
    let resolve, reject;
    try {

        const recaptchaPromise = new Promise((res, rej) => {
            resolve = res;
            reject = rej;
        });

        timer = setTimeout(() => reject("reCAPTCHA timed out"), 10000);

        const gkey = document.getElementById("gReCAPTCHASiteKey").value;
        window.grecaptcha.ready(() => {
            try {

                window.grecaptcha
                    .execute(gkey, { action: actionName })
                    .then((token) => {

                        // Add the recaptcha challenge token to the appropriate form input.
                        const reCaptchaToken = document.getElementById("reCaptchaToken");
                        if (reCaptchaToken) {
                            reCaptchaToken.value = token;
                        }
                        
                        clearTimeout(timer);
                        resolve(token);
                    })
                    .catch((e) => {
                        recaptchaPipelineError(e);
                    });

            } catch (e) {
                recaptchaPipelineError(e);
            }
        });

        return recaptchaPromise;

    } catch (e) {
        clearTimeout(timer);
        console.error(e);
        throw "Something went wrong while setting up reCAPTCHA";
    }

    function recaptchaPipelineError(e) {
        clearTimeout(timer);
        console.error(e);
        reject(new Error("Something went wrong while executing reCAPTCHA"));
    }

}